import script from "./YourDetailsFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./YourDetailsFormView.vue?vue&type=script&setup=true&lang=js"

import "./YourDetailsFormView.vue?vue&type=style&index=0&id=253c9fa5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-253c9fa5"]])

export default __exports__